angular.module('bmsApp.merrymaids.job')
	.controller('MMCancelJobModalCtrl', [
		'$q',
		'MMJobSvc',
		'$modalInstance',
		'AppSettingsSvc',
		'job',
		function ($q,
				  MMJobSvc,
				  $modalInstance,
				  AppSettingsSvc,
				  job) {

			var self = this;

			angular.extend(self, {
				loading: false,
				loaded: false,
				errors: undefined,
				data: {
					job: job,
					inactivate_customer: false
				},
				options: {},
				formValidator: {
					config: {
						errorPlacement: function (error) {
							error.appendTo('#form-errors');
						},
						errorContainer: '#form-errors'
					},
					api: {}
				},
				submitPromise: undefined,
				methods: {
					init: init,
					cancel: cancel,
					submit: submit
				}
			});

			function init() {
				self.loading = true;
				var cancelReasonOptionPromise = MMJobSvc.jobCancelReasonOptions()
					.then(function (response) {
						angular.extend(self.options, {
							cancelReason: response.data.options
						});
					});
				var appSettings = AppSettingsSvc.index()
					.then(function (response) {
						self.appSettings = response.data.settings;
						self.data.send_email_notification = self.appSettings.send_job_cancellation_email;
					});

				$q.all([
					cancelReasonOptionPromise,
					appSettings
				])
					.then(function () {
						self.loading = false;
						self.loaded = true;
					});
			}

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit(form) {
				self.errors = undefined;
				if (form.$valid) {
					self.submitPromise = MMJobSvc.cancel(self.data)
						.then(function () {
							$modalInstance.close({
								success: true
							});
						}, function (errors) {
							self.errors = errors;
						});
				}
			}

		}
	]);
